import React, { ReactElement } from 'react'
import { CourseConfigType } from 'common/src/courseConfig'
import { GetStaticProps } from 'next'
import { getAvailableCourseTracks } from '@/components/sharedFetchStaticProps/getAvailableCourseTracks'
import { CourseInfo } from 'common/src/api/core/courses/types'
import { CoursesPage } from '@/components/Courses/CoursesPage'
import { NextSeo } from 'next-seo'

export const getStaticProps = (async (_context) => {
    const courseConfigType = CourseConfigType.fsaHealth
    const response = await getAvailableCourseTracks(courseConfigType)
    return { props: { ...response, courseConfigType } }
}) satisfies GetStaticProps<{
    coursesInfo: CourseInfo[]
    courseConfigType: CourseConfigType
}>
const Page = (props: {
    coursesInfo: CourseInfo[]
    courseConfigType: CourseConfigType
}): ReactElement => {
    return (
        <>
            <NextSeo
                title={
                    'Just Enough Prep | FSA CP321 Actuarial Exam Preparation'
                }
                description={
                    'Just Enough Prep offers expertly curated resources, including in-depth study guides, practice tests, and personalized support, specifically designed to help actuaries master the complex concepts and strategies needed to pass the FSA Group & Health Design & Pricing Exam.'
                }
            />
            <CoursesPage
                {...props}
                isLoggedIn={false}
                userPaymentHistory={null}
                demoHistory={null}
                setUserInfo={null}
                courseName={'cp_321'}
            />
        </>
    )
}

Page.isStatic = true

export default Page
